var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seoMarkup"},_vm._l((_vm.filterSeoContent),function(seo){return _c('div',{key:seo.id,staticClass:"seoMarkup__content"},[(_vm.showHeader)?_c('h1',[_vm._v(_vm._s(seo.title))]):_vm._e(),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(seo.content)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }